/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { J5RegistryV1ArtifactEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const J5_REGISTRY_V1_ARTIFACT_EVENT_ENTITY_NAME = 'j5.registry.v1.ArtifactEvent';
export const j5RegistryV1ArtifactEventEntity = new schema.Entity<J5RegistryV1ArtifactEvent>(J5_REGISTRY_V1_ARTIFACT_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: J5RegistryV1ArtifactEvent) => `${entity.metadata?.eventId}` });

